import React, { useCallback, useEffect, useState } from 'react';
import { cn } from '../../../utils/utils';

import { SearchOutlined } from '@ant-design/icons';

import { Button, Input, Select } from 'antd';
import ModalCom from '../../../components/ModalCom/index.jsx';
import { getProjectList, postProjectDetail, postProjectResponse } from '../../../api/request.js';
import { useRoot } from '../../../hooks/useRoot.jsx';
import { useNavigate } from 'react-router-dom';

let timeout = null;

const getData = async (search = '', callback) => {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  } else {
    timeout = setTimeout(async () => {
      let result = [];
      try {
        const params = {
          page: 1,
          page_size: 30,
          sort: '-created_at',
          search: search
        };
        const response = await getProjectList(params);
        const {  status, data = [], } = response || {};
        if(status === 200) {
          result = data.map(item => {
            return {
              label: item.title,
              value: item.id
            };
          });
        }
      } catch(error) {
        result = [];
      } finally {
        callback(result);
        // setAllNamelist(result);
        // setProNamelist(result);
      }
    }, 300);
  }
};

const ProjectWinCom = ({showWin, className ='', onCloseWin}) => {
  const navigate = useNavigate();
  const { setShowProjectWin, showProjectWin, videoList } = useRoot();
  const [allNameList, setAllNamelist] = useState([]);
  const [curProId, setCurProId] = useState(''); 
  const [customName, setCustomName] = useState(''); 

  useEffect(() => {
    if(showProjectWin) {
      setCurProId('');
      setCustomName('');
    }
  }, [showProjectWin]);

  useEffect(() => {
    getData('', setAllNamelist);
  }, []);

  const handleSearch = async(newValue = '') => {
    getData(newValue, setAllNamelist);
  };

  const handleChange = (newValue) => {
    setCurProId(newValue);
  };

  const fnCreateResponse = useCallback(async (curProId) => {
    const responseList =  videoList.map(item => {
      return {
        ...item,
        title: item.video_path.split('/')[1]
      };
    });
    const result = await postProjectResponse(curProId, {
      responses: responseList
    });
    if(result.status === 'Success') {
      navigate('/consumer-theatre-processing/project/detail/'+curProId);
      setShowProjectWin(false);
    }
  }, [videoList]);

  const fnCreatePorject = async () => {
    try {
      if(curProId) {
        await fnCreateResponse(curProId);
      } else {
        const params = {
          'title': customName,
          'cover_image_path': ''
        };
        const result = await postProjectDetail(params);
        if(result.status === 'Success') {
          const proId = result.data.id;
          await fnCreateResponse(proId);
        }
      }
    } catch(error) {
      console.log(error);
    }
  };

  return <ModalCom showWin={showWin} className={cn('!w-[40%] min-w-[520px]', className)} onCloseWin={onCloseWin}>
    <div className="px-[22px]">
      <div className="text-[24px] font-semibold leading-none mb-4">Import project selection</div>
      <div className="text-base text-grey-3 leading-none mb-6">What do you want to upload your content?</div>

      <div className="px-[25px] py-[20px] rounded-lg bg-[#FAFAFA] mb-[25px]">
        <span className="text-lg leading-none">Add to existing project</span>
        <div className="h-[25px]"></div>
        <div className='relative'>
          <Select
            disabled={customName}
            className="w-full h-[47px] [&_.ant-select-selection-item]:!ml-[25px] [&_.ant-select-selection-search-input]:!ml-[25px] [&_div.ant-select-selector]:!bg-third [&_.ant-select-selector]:!border-none" size="middle" prefix={<SearchOutlined style={{ fontSize: '16px', fontWeight: 'bold' }} className="font-semibold text-primary"/>}
            showSearch
            allowClear
            value={curProId}
            onSearch={handleSearch}
            onChange={handleChange}
            filterOption={false}
            notFoundContent={null}
            options={allNameList}
          />
          <SearchOutlined style={{ fontSize: '16px', fontWeight: 'bold' }} className="font-semibold text-primary absolute top-[15px] left-[10px]"/>
        </div>
        {/* <Input className="h-[47px] bg-third border-none" size="middle" prefix={} /> */}
      </div>

      <div className="px-[25px] py-[20px] rounded-lg bg-[#FAFAFA]">
        <span className="text-lg leading-none mb-[25px]">Create new project</span>
        <div className="h-[25px]"></div>
        <Input disabled={curProId} value={customName} onChange={(e) => setCustomName(e.target.value.trim())} className="h-[47px] bg-third border-none" size="middle" />
      </div>
           
      <div className="mt-[30px] flex justify-center items-center">
        <Button onClick={() => setShowProjectWin(false)} className="w-[135px] border-[#DBDADA] text-grey-3 shadow-none rounded-2xl">Cancel</Button>
        <div className="w-[25px]"></div>
        <Button onClick={fnCreatePorject} type="primary" className="w-[135px] border-none shadow-none rounded-2xl">Save</Button>
      </div>
    </div>
  </ModalCom>;
};

export default ProjectWinCom;